import { j as s } from "./index.es33.js";
import { Checkbox as p } from "./index.es11.js";
import { useSelectContext as x } from "./index.es132.js";
import { Option as f } from "./index.es161.js";
import { SelectSize as v } from "./index.es135.js";

var O = function O(_ref) {
  var e = _ref.value,
      _ref$size = _ref.size,
      i = _ref$size === void 0 ? v.normal : _ref$size,
      m = _ref.children,
      n = _ref.isIndeterminate,
      a = _ref.isChecked,
      r = _ref.isDisabled,
      t = _ref.onClick;

  var _x = x(),
      o = _x.value,
      c = _x.onOptionClick,
      l = function l() {
    t ? t() : c === null || c === void 0 ? void 0 : c(e);
  };

  return s.jsx(f, {
    value: e,
    size: i,
    isSelected: !1,
    onClick: l,
    isDisabled: r,
    children: s.jsx(p, {
      isDisabled: r,
      isIndeterminate: n,
      isSkipFocus: !0,
      onChange: l,
      isValue: !!(a || (Array.isArray(o) ? o.some(function (u) {
        return u.value === (e === null || e === void 0 ? void 0 : e.value);
      }) : (o === null || o === void 0 ? void 0 : o.value) === (e === null || e === void 0 ? void 0 : e.value))),
      children: m
    })
  });
};

export { O as CheckboxOption };